import React from 'react';
import clsx from 'clsx';
import { Icon } from 'components/ui/Icon';
import styles from './FieldShell.module.scss';

export function RequiredMark() {
  return (
    <span className={styles.required} aria-hidden="true">
      {' *'}
    </span>
  );
}

export interface IFieldShellProps {
  label: string;
  id: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export default function FieldShell({
  label,
  id,
  error,
  disabled = false,
  required = false,
  className,
  children,
}: IFieldShellProps) {
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div
      className={clsx(styles.shell, disabled && styles.disabled, className)}
    >
      <label className={styles.label} htmlFor={id}>
        {label}
        {required ? <RequiredMark /> : null}
      </label>
      <div className={styles.controlWrap}>{children}</div>
      {error ? (
        <p className={styles.error} id={errorId} role="alert">
          <Icon name="alert-circle" size={16} className={styles.errorIcon} />
          <span>{error}</span>
        </p>
      ) : null}
    </div>
  );
}
